import custom_fetch from "../custom_fetch";
import {BASE_URL} from "./base_url";

const get_accidents_by_token = (token) => {
    const url = `${BASE_URL}/Accidents/GetAccidentsByToken?Token=${encodeURIComponent(token)}`;
    return custom_fetch(url, {
        method: 'POST'
    }).then(data => {
        return data;
    }).catch(error => {
        throw error;
    })
}

export default get_accidents_by_token;